import state from './state'
import * as THREE from 'three'

const camera = new THREE.PerspectiveCamera(
  60,
  window.innerWidth / window.innerHeight,
  0.2,
  2000,
)

//setCamera(-12, 10, 0)
setCamera(-55, 55, 0)

export default camera

export function setCamera(x, y, z) {
  state.camera.position = {
    x,
    y,
    z,
  }
  camera.position.set(x, y, z)
}
